export const configureGantt = (gantt, rowHeight, cellWidth, splitterWidth, showSubtasksRef) => {
    gantt.config.columns = [
        { name: "text", label: "Crew", width: splitterWidth, tree: false, resize: false },
    ];
    gantt.config.grid_width = splitterWidth;

    gantt.config.scales = [
        { unit: "month", step: 1, format: "%F, %Y", sticky: false },
        { unit: "day", step: 1, date: cellWidth < 12 ? "%j" : "%j %D", sticky: false },
        {
            unit: "hour",
            step: cellWidth < 6 ? 12 : cellWidth < 12 ? 6 : cellWidth < 18 ? 4 : cellWidth < 24 ? 2 : 1,
            date: "%G",
            sticky: false,
        },
    ];

    gantt.config.duration_unit = "hour";
    gantt.config.duration_step = 1;
    gantt.config.scale_height = 60;
    gantt.config.row_height = rowHeight;
    gantt.config.min_column_width = cellWidth;
    gantt.config.min_grid_width = 80;
    gantt.config.readonly = true;
    gantt.config.escape_html = false;
    gantt.config.layout = {
        css: "gantt_container",
        rows: [
            {
                cols: [
                    { view: "grid", scrollX: "scrollHor", scrollY: "scrollVer" },
                    { resizer: true, width: 4 },
                    { view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer" },
                    { view: "scrollbar", id: "scrollVer" },
                ],
            },
            { view: "scrollbar", id: "scrollHor", height: 20 },
        ],
    };

    gantt.templates.task_height = () => rowHeight - 4;

    gantt.templates.task_date = (date) =>
        gantt.date.date_to_str("%H:%i %d/%m/%Y")(date);

    gantt.templates.task_text = (start, end, task) => {
        const subtasks = showSubtasksRef.current?.(task);
        return subtasks ||
            `<span>
                <div class="crew-multi-line-text">
                    ${task.text}
                </div>
            </span>`;
    };

    gantt.templates.task_class = (start, end, task) =>
        task.isParent ? "parent-task" : "";

    gantt.templates.timeline_cell_class = () => "";

    gantt.templates.task_bar = (start, end, task) => {
        if (task.isParent) return "";
        if (task.parent) {
            const color = task.sectorType === 'Domestic'
                ? 'rgb(166, 198, 232)'
                : task.sectorType === 'International'
                    ? 'rgb(255, 165, 0)'
                    : 'rgb(0, 255, 238)';
            return `<div style='background-color:${color}; height: 100%;'></div>`;
        }
        return "<div style='background-color:rgb(98, 194, 120); height: 100%;'></div>";
    };

    gantt.templates.grid_row_class = (start, end, task) =>
        task.isParent ? "gantt-parent-row clickable-row" : "";
};
